import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: '',
    email: '',
    phone: '',
    address: '',
    avatar: '',
    access_token: '',
    id: '',
    isAdmin: false,
    city: "",
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        updateUser: (state, action) => {
            const { name = '', email = '', access_token = '', phone = '', address = '', avatar = '', _id = '', isAdmin, city = '' } = action.payload
            state.name = name || email
            state.email = email
            state.phone = phone
            state.address = address
            state.avatar = avatar
            state.id = _id
            state.access_token = access_token
            state.isAdmin = isAdmin
            state.city = city
        },
        resetUser: (state) => {
            state.name = ""
            state.email = ""
            state.phone = ''
            state.address = ''
            state.avatar = ''
            state.id = ''
            state.access_token = ''
            state.isAdmin = false
            state.city = ""
        },
    },
})

export const { updateUser, resetUser } = userSlice.actions

export default userSlice.reducer